export const args = [
  {
    title: 'Shipping Heading',
    key: 'shippingTitle',
    type: 'string',
  },
  {
    title: 'Box Status Heading',
    key: 'boxStatusTitle',
    type: 'string',
  },
  {
    title: 'Box Status Billing CTA Text',
    key: 'boxStatusBillingCTA',
    type: 'string',
  },
  {
    title: 'Box Status Tracking CTA Text',
    key: 'boxStatusTrackingCTA',
    type: 'string',
  },
  {
    title: 'Refer Heading',
    key: 'referTitle',
    type: 'string',
  },
  {
    title: 'Refer Description',
    key: 'referDescription',
    type: 'string',
  },
  {
    title: 'Refer CTA Text',
    key: 'referCTA',
    type: 'string',
  },
  {
    title: 'Upgrade CTA Text',
    key: 'upgradeCTA',
    type: 'string',
  },
  {
    title: 'Upgrade Heading',
    key: 'upgradeTitle',
    type: 'string',
  },
  {
    title: 'Upgrade Description',
    key: 'upgradeDescription',
    type: 'string',
  },
  {
    title: 'Box Status Processing',
    key: 'boxStatuses.BOX_STATUS_PROCESSING',
    type: 'string',
  },
  {
    title: 'Box Status Assigned',
    key: 'boxStatuses.BOX_STATUS_ASSIGNED',
    type: 'string',
  },
  {
    title: 'Box Status Shipped',
    key: 'boxStatuses.BOX_STATUS_SHIPPED',
    type: 'string',
  },
  {
    title: 'Box Status Delivered',
    key: 'boxStatuses.BOX_STATUS_DELIVERED',
    type: 'string',
  },
  {
    title: 'Box Status Probably Delivered',
    key: 'boxStatuses.BOX_STATUS_PROBABLY_DELIVERED',
    type: 'string',
  },
  {
    title: 'Box Status No Box',
    key: 'boxStatuses.BOX_STATUS_NO_BOX',
    type: 'string',
  },
];

export default {
  args,
};
